export default {"src":"/_next/static/media/no-data-reminder.82fcb64b.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};